import { services } from '../content/services'
import { projects } from '../content/projects'
import { sectors } from '../content/sectors'
import { jobs } from '../content/jobs'
import { news } from '../content/news'

export interface SearchResult {
  kind: 'Project' | 'Service' | 'Sector' | 'Vacancy' | 'News'
  title: string
  href: string
}

interface Entry extends SearchResult {
  /** Concatenated searchable text. */
  hay: string
}

/** Built once — the content modules are static. */
const index: Entry[] = [
  ...projects.map<Entry>((p) => ({
    kind: 'Project',
    title: p.title,
    href: `/projects/${p.slug}`,
    hay: `${p.title} ${p.sector} ${p.province} ${p.client}`,
  })),
  ...services.map<Entry>((s) => ({
    kind: 'Service',
    title: s.title,
    href: `/services/${s.slug}`,
    hay: `${s.title} ${s.blurb}`,
  })),
  ...sectors.map<Entry>((s) => ({
    kind: 'Sector',
    title: s.name,
    href: '/sectors',
    hay: `${s.name} ${s.blurb}`,
  })),
  ...jobs.map<Entry>((j) => ({
    kind: 'Vacancy',
    title: j.title,
    href: '/careers',
    hay: `${j.title} ${j.loc} ${j.dept}`,
  })),
  ...news.map<Entry>((n) => ({
    kind: 'News',
    title: n.title,
    href: '/news',
    hay: `${n.title} ${n.tag}`,
  })),
].map((e) => ({ ...e, hay: e.hay.toLowerCase() }))

const LIMIT = 10

export function search(query: string): SearchResult[] {
  const q = query.trim().toLowerCase()
  if (!q) return []
  return index
    .filter((e) => e.hay.includes(q))
    .slice(0, LIMIT)
    .map(({ kind, title, href }) => ({ kind, title, href }))
}
